// extracted by mini-css-extract-plugin
export var aircallIframe = "_iz-3";
export var fabContainer = "_iz-5";
export var fabRinging = "_iz-6";
export var loadingOverlay = "_iz-4";
export var pulse = "_iz-7";
export var widgetContent = "_iz-2";
export var widgetPanel = "_iz-0";
export var widgetPanelExpanded = "_iz-1";